define(['services/validators', 'services/converters', 'common/searchTypes', 'common/parameterApplications'],
    function(validators, converters, searchTypes, parameterApplications) {

        return {
            create: function() {
                return {
                    key: {validator: validators.string},
                    query: {
                        validator: validators.string, converter: converters.queryString, required: true,
                        application: parameterApplications.PATH
                    },
                    typeahead: {validator: validators.bool},
                    limit: {validator: validators.limit},
                    offset: {validator: validators.offset, name: 'ofs'},
                    language: {
                        validator: validators.languageCode,
                        converter: converters.language,
                        defaultValue: 'en-GB'
                    },
                    countrySet: {validator: validators.countrySet},
                    radius: {validator: validators.positiveInteger},
                    boundingBox: {validator: validators.boundingBox, converter: converters.boundingBox},
                    center: {converter: converters.point, validator: validators.point},
                    type: {
                        validator: validators.string, defaultValue: searchTypes.search,
                        application: parameterApplications.PATH
                    },
                    bestResult: {validator: validators.bool},
                    protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')},
                    extendedPostalCodesFor: {validator: validators.string},
                    unwrapBbox: {validator: validators.bool, defaultValue: false, required: true},
                    view: {validator: validators.geopolView('search', 'view')}
                };
            },
            modifyRequestOptions: function(requestOptions) {
                var bestResult = Boolean(requestOptions.bestResult);
                if (bestResult) {
                    requestOptions.limit = 1;
                    requestOptions.offset = 0;
                }

                if (requestOptions.center) {
                    requestOptions.center = requestOptions.center.split(',');
                    requestOptions.lat = requestOptions.center[0];
                    requestOptions.lon = requestOptions.center[1];
                    delete requestOptions.center;
                }
            },

            /*
            * At this moment it's impossible to map one field to two and more output fields but we need to do this, e.g.
            * bounding box needs to be mapped to topLeft and btmRight. That's why this method tries to fix this
            */
            modifyFields: function(fields) {
                var resultFields = Object.assign({}, fields);
                if (resultFields.boundingBox) {
                    resultFields.topLeft = {};
                    resultFields.btmRight = {};
                    delete resultFields.boundingBox;
                }

                if (resultFields.center) {
                    resultFields.lat = {};
                    resultFields.lon = {};
                    delete resultFields.center;
                }

                return resultFields;
            }
        };
    });



// WEBPACK FOOTER //
// ./services/search/searchParameters.js